import { React, useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MDBBtn, MDBContainer, MDBRadio } from "mdb-react-ui-kit";
import TextBox from "../../components/common/TextBox";
import Button from "../../components/cofButton/Button";
import { useDispatch, useSelector } from "react-redux";
import { getUserWeeklyoverview } from "../../actions/weeklyoverviewActions";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { submitDailyStatus } from "../../actions/submitActions";
import { submitDailyStatusAgain } from "../../actions/submitAgainActions";
import { getDailyStatus } from "../../actions/dailyStatusActions";
import { useTranslation } from 'react-i18next';
import { SUBMIT_AGAIN_RESET } from "../../constants/submitAgainConstants";
import { DAILY_STATUS_RESET } from "../../constants/dailyStatusConstants";
import { SUBMIT_RESET } from "../../constants/submitConstants";
import './Daily.css';

const DailySurveyScreen = () => {
  const [isSubmitSuccessful, setIsSubmitSuccessful] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [mentalDetails, setMentalDetails] = useState("");
  const [fitnessDetails, setFitnessDetails] = useState("");
  const [bedTimeHour, setBedTimeHour] = useState("00");
  const [bedTimeMinute, setBedTimeMinute] = useState("00");
  const [wakeTimeHour, setWakeTimeHour] = useState("00");
  const [wakeTimeMinute, setWakeTimeMinute] = useState("00");

  // Kombinovanje bedTime i wakeTime u format "HH:mm"
  const bedTime = `${String(bedTimeHour).padStart(2, "0")}:${String(bedTimeMinute).padStart(2, "0")}`;
  const wakeTime = `${String(wakeTimeHour).padStart(2, "0")}:${String(wakeTimeMinute).padStart(2, "0")}`;

  const [showFitnessTextBox, setShowFitnessTextBox] = useState(false);
  const [showMentalTextBox, setShowMentalTextBox] = useState(false);
  const [showSleepTextBox, setShowSleepTextBox] = useState(false);
  const [isTextBoxFilled, setIsTextBoxFilled] = useState(true);
  const [submitButtonClicked, setSubmitButtonClicked] = useState(false);

  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const weeklyoverview = useSelector((state) => state.weeklyoverview);
  const dailystatuses = weeklyoverview ? weeklyoverview.weeklyoverview : null;

  const dailystatus = useSelector((state) => state.dailyStatus);

  const submitStatus = useSelector((state) => state.submit);
  const { loading, error, success } = submitStatus

  const submitStatusAgain = useSelector((state) => state.submitAgain)
  const { loading: loadingAgain, error: errorAgain, success: successAgain } = submitStatusAgain

  const getDaily = useSelector((state) => state.dailyStatus)
  const { loading: loadingDaily, error: errorDaily, success: successDaily } = getDaily
  const [errorAlert, setErrorAlert] = useState(false);

  useEffect(() => {
    if (success) {
      // Show success message immediately
      setIsSubmitSuccessful(true);
      
      // Delay navigation to show success message
      const timeoutId = setTimeout(() => {
        navigate(`/`);
        // Reset the submit state to ensure proper re-rendering
        dispatch({ type: SUBMIT_RESET });
        // Remove window.location.reload() as it can cause issues on host
        // Instead, dispatch an action to refresh the data
        dispatch(getUserWeeklyoverview(userInfo._id));
      }, 4000); // 4 second delay to ensure message is visible on host
      
      // Cleanup timeout if component unmounts
      return () => clearTimeout(timeoutId);
    } else if (error) {
      setErrorAlert(true);
    }
    
    // Reset success message when success state changes to false
    if (!success && !error) {
      setIsSubmitSuccessful(false);
      setErrorAlert(false);
    }
  }, [navigate, success, error, dispatch, userInfo._id]);

  const todaystatus = dailystatus && dailystatus.dailystatus && dailystatus.dailystatus.length > 0 ? dailystatus.dailystatus[0] : null;

  const [fitnessStatus, setFitnessStatus] = useState('');
  const [mentalStatus, setMentalStatus] = useState('');
  const [sleepStatus, setSleepStatus] = useState('');

  useEffect(() => {
    if (dailystatuses === null) {
      dispatch(getUserWeeklyoverview(userInfo._id));
    }
    // Reset success message state when component mounts
    setIsSubmitSuccessful(false);
    setErrorAlert(false);
    setSubmitButtonClicked(false);
  }, [dispatch, userInfo._id, dailystatuses]);

  useEffect(() => {
    if (todaystatus && todaystatus.physicalStatus) {
      setFitnessStatus(todaystatus.physicalStatus.toString());
    }
    if (todaystatus && todaystatus.mentalStatus) {
      setMentalStatus(todaystatus.mentalStatus.toString());
    }
    if (todaystatus === null || todaystatus.length === 0) {
      dispatch(getDailyStatus(userInfo._id));
    }
  }, [dispatch, userInfo._id, todaystatus]);

  const handleFitnessChange = (event) => {
    setFitnessStatus(event.target.value);
    setShowFitnessTextBox(Number(event.target.value) <= 3);
    setIsTextBoxFilled(Number(event.target.value) > 3);
  };

  const handleMentalChange = (event) => {
    setMentalStatus(event.target.value);
    setShowMentalTextBox(Number(event.target.value) <= 3);
    setIsTextBoxFilled(Number(event.target.value) > 3);
  };

  const handleSleepChange = (event) => {
    setSleepStatus(event.target.value);
  };

  const handleFitnessDetailsChange = (event) => {
    setFitnessDetails(event.target.value);
    setSubmitButtonClicked(false);
    setIsTextBoxFilled(!!event.target.value);
  };

  const handleMentalDetailsChange = (event) => {
    setMentalDetails(event.target.value);
    setSubmitButtonClicked(false);
    setIsTextBoxFilled(!!event.target.value);
  };

  const handleSubmit = () => {
    if ((showFitnessTextBox && fitnessStatus <= 3 && !fitnessDetails) || 
        (showMentalTextBox && mentalStatus <= 3 && !mentalDetails) ||
        (!fitnessStatus || !mentalStatus || !sleepStatus || !bedTime || !wakeTime)) {
      setSubmitButtonClicked(true);
      alert("Molimo Vas da popunite sve obavezne informacije pre nego što nastavite.");
      return;
    }

    const requestBody = {
      physicalStatus: fitnessStatus,
      mentalStatus: mentalStatus,
      physicalDescription: fitnessDetails,
      mentalDescription: mentalDetails,
      bedTime: bedTime,
      wakeTime: wakeTime,
      sleepStatus: sleepStatus,
    };
    dispatch(submitDailyStatus(userInfo._id, requestBody));
  };

  useEffect(() => {
    if (successAgain) {
      // Show success message first, then navigate
      setIsSubmitSuccessful(true);
      
      // Delay navigation to show success message
      const timeoutId = setTimeout(() => {
        navigate(`/`);
        dispatch({ type: SUBMIT_AGAIN_RESET });
        dispatch({ type: DAILY_STATUS_RESET });
        // Remove window.location.reload() and use dispatch instead
        dispatch(getUserWeeklyoverview(userInfo._id));
      }, 4000); // 4 second delay to ensure message is visible on host
      
      // Cleanup timeout if component unmounts
      return () => clearTimeout(timeoutId);
    } else if (errorAgain) {
      setErrorAlert(true);
    }
    
    // Reset success message when successAgain state changes to false
    if (!successAgain && !errorAgain) {
      setIsSubmitSuccessful(false);
      setErrorAlert(false);
    }
  }, [successAgain, errorAgain, successDaily, errorDaily, navigate, dispatch, userInfo._id]);

  const handleSubmitAgain = (e) => {
    e.preventDefault();
    if ((showFitnessTextBox && fitnessStatus <= 3 && !fitnessDetails) || 
        (showMentalTextBox && mentalStatus <= 3 && !mentalDetails)) {
      setSubmitButtonClicked(true);
      return;
    }

    const requestBodyNew = {
      physicalStatus: fitnessStatus,
      mentalStatus: mentalStatus,
      physicalDescription: fitnessDetails,
      mentalDescription: mentalDetails,
    };

    dispatch(submitDailyStatusAgain(userInfo._id, requestBodyNew));
  };

  // Render existing status
  if (todaystatus) {
    return (
      <div className="daily-survey-container">
        <div className="today-status">
          <h3 className="status-header">{t("Todays input").toUpperCase()}</h3>
          <h3>{t("Fitness status today")}: {todaystatus.physicalStatus}</h3>
          <h3>{t("Mental status today")}: {todaystatus.mentalStatus}</h3>
          <h3>{t("ocenakvalitetasna")}: {todaystatus.sleepStatus}</h3>
        </div>

        <div className="survey-card">
          <h2 className="survey-title">{t("Daily survey")}</h2>
          
          {/* Fitness Section */}
          <div style={{ marginBottom: '32px' }}>
            <p className="section-header">{t("How is your fitness status today")}?</p>
            <div className="radio-group">
              {[1, 2, 3, 4, 5].map((value) => (
                <div key={value} className="radio-item">
                  <input
                    type="radio"
                    id={`fitness-${value}`}
                    name="fitnessStatus"
                    value={value.toString()}
                    onChange={handleFitnessChange}
                    checked={fitnessStatus === value.toString()}
                  />
                  <label htmlFor={`fitness-${value}`} className="radio-button">
                    {value}
                  </label>
                </div>
              ))}
            </div>
            {showFitnessTextBox && (
              <div className="modern-textbox">
                <TextBox 
                  label={t("Fitness Details")} 
                  text={fitnessDetails}
                  showTextBox={showFitnessTextBox}
                  onInputChange={handleFitnessDetailsChange}
                />
              </div>
            )}
          </div>

          {/* Mental Section */}
          <div style={{ marginBottom: '32px' }}>
            <p className="section-header">{t("How is your mental status today")}?</p>
            <div className="radio-group">
              {[1, 2, 3, 4, 5].map((value) => (
                <div key={value} className="radio-item">
                  <input
                    type="radio"
                    id={`mental-${value}`}
                    name="mentalStatus"
                    value={value.toString()}
                    onChange={handleMentalChange}
                    checked={mentalStatus === value.toString()}
                  />
                  <label htmlFor={`mental-${value}`} className="radio-button">
                    {value}
                  </label>
                </div>
              ))}
            </div>
            {showMentalTextBox && (
              <div className="modern-textbox">
                <TextBox 
                  label={t("Mental Details")} 
                  text={mentalDetails}
                  showTextBox={showMentalTextBox}
                  onInputChange={handleMentalDetailsChange}
                />
              </div>
            )}
          </div>

          <div className="submit-container">
            <button className="modern-submit-btn" onClick={handleSubmitAgain}>
              {t("Submit again")}
            </button>
          </div>

          {submitButtonClicked && (
            <div className="status-message error">
              {t("You need to fill the textbox in order to proceed further")}.
            </div>
          )}

          {!isTextBoxFilled && (
            <div className="status-message error">
              {t("You need to fill the textbox before clicking the submit button")}.
            </div>
          )}

          {isSubmitSuccessful && (
            <div className="status-message success" style={{ 
              fontSize: '18px', 
              fontWeight: '600',
              padding: '20px',
              margin: '20px 0',
              textAlign: 'center',
              backgroundColor: 'rgba(40, 167, 69, 0.3)',
              border: '2px solid rgba(40, 167, 69, 0.6)',
              borderRadius: '12px',
              color: '#51cf66',
              animation: 'fadeInUp 0.5s ease-out'
            }}>
              ✅ {t("Submission was successful")}! {t("redirectingToHome")}
            </div>
          )}

        </div>
      </div>
    )
  } 

  // Render new survey
  return (
    <div className="daily-survey-container">
      <div className="survey-card">
        <h2 className="survey-title">{t("Daily survey").toUpperCase()}</h2>
        <p className="survey-subtitle">Kako se osećate danas?</p>
        
        {/* Fitness Section */}
        <div style={{ marginBottom: '40px' }}>
          <p className="section-header">{t("How is your fitness status today")}?</p>
          <div className="radio-group">
            {[1, 2, 3, 4, 5].map((value) => (
              <div key={value} className="radio-item">
                <input
                  type="radio"
                  id={`fitness-${value}`}
                  name="fitnessStatus"
                  value={value.toString()}
                  onChange={handleFitnessChange}
                  checked={fitnessStatus === value.toString()}
                />
                <label htmlFor={`fitness-${value}`} className="radio-button">
                  {value}
                </label>
              </div>
            ))}
          </div>
          {showFitnessTextBox && (
            <div className="modern-textbox">
              <TextBox 
                label={t("Fitness Details")} 
                text={fitnessDetails}
                showTextBox={showFitnessTextBox}
                onInputChange={handleFitnessDetailsChange}
              />
            </div>
          )}
        </div>

        {/* Mental Section */}
        <div style={{ marginBottom: '40px' }}>
          <p className="section-header">{t("How is your mental status today")}?</p>
          <div className="radio-group">
            {[1, 2, 3, 4, 5].map((value) => (
              <div key={value} className="radio-item">
                <input
                  type="radio"
                  id={`mental-${value}`}
                  name="mentalStatus"
                  value={value.toString()}
                  onChange={handleMentalChange}
                  checked={mentalStatus === value.toString()}
                />
                <label htmlFor={`mental-${value}`} className="radio-button">
                  {value}
                </label>
              </div>
            ))}
          </div>
          {showMentalTextBox && (
            <div className="modern-textbox">
              <TextBox 
                label={t("Mental Details")} 
                text={mentalDetails}
                showTextBox={showMentalTextBox}
                onInputChange={handleMentalDetailsChange}
              />
            </div>
          )}
        </div>

        {/* Sleep Section */}
        <div className="time-section">
          <h3 className="section-header">{t("SleepData")}</h3>
          
          <div style={{ marginBottom: '24px' }}>
            <p className="section-header" style={{ fontSize: '16px', marginBottom: '16px' }}>
              {t("SleepRate")}?
            </p>
            <div className="radio-group">
              {[1, 2, 3, 4, 5].map((value) => (
                <div key={value} className="radio-item">
                  <input
                    type="radio"
                    id={`sleep-${value}`}
                    name="sleepStatus"
                    value={value.toString()}
                    onChange={handleSleepChange}
                    checked={sleepStatus === value.toString()}
                  />
                  <label htmlFor={`sleep-${value}`} className="radio-button">
                    {value}
                  </label>
                </div>
              ))}
            </div>
          </div>

          <div className="time-selector-container">
            <div className="time-selector">
              <label>{t("BedTime")}</label>
              <div className="time-inputs">
                <select value={bedTimeHour} onChange={(e) => setBedTimeHour(e.target.value)}>
                  {Array.from({ length: 24 }, (_, i) => (
                    <option key={i} value={String(i).padStart(2, "0")}>
                      {String(i).padStart(2, "0")}
                    </option>
                  ))}
                </select>
                <span className="time-separator">:</span>
                <select value={bedTimeMinute} onChange={(e) => setBedTimeMinute(e.target.value)}>
                  {["00", "10", "20", "30", "40", "50"].map((minute) => (
                    <option key={minute} value={minute}>
                      {minute}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="time-selector">
              <label>Wake Time</label>
              <div className="time-inputs">
                <select value={wakeTimeHour} onChange={(e) => setWakeTimeHour(e.target.value)}>
                  {Array.from({ length: 24 }, (_, i) => (
                    <option key={i} value={String(i).padStart(2, "0")}>
                      {String(i).padStart(2, "0")}
                    </option>
                  ))}
                </select>
                <span className="time-separator">:</span>
                <select value={wakeTimeMinute} onChange={(e) => setWakeTimeMinute(e.target.value)}>
                  {["00", "10", "20", "30", "40", "50"].map((minute) => (
                    <option key={minute} value={minute}>
                      {minute}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="time-display">
            <p>Bed Time: {bedTime}</p>
            <p>Wake Time: {wakeTime}</p>
          </div>
        </div>

        <div className="submit-container">
          <button className="modern-submit-btn" onClick={handleSubmit}>
            {t("Submit")}
          </button>
        </div>

        {submitButtonClicked && (
          <div className="status-message error">
            {t("You need to fill the textbox in order to proceed further")}.
          </div>
        )}

        {!isTextBoxFilled && (
          <div className="status-message error">
            {t("You need to fill the textbox before clicking the submit button")}.
          </div>
        )}

        {isSubmitSuccessful && (
          <div className="status-message success" style={{ 
            fontSize: '18px', 
            fontWeight: '600',
            padding: '20px',
            margin: '20px 0',
            textAlign: 'center',
            backgroundColor: 'rgba(40, 167, 69, 0.3)',
            border: '2px solid rgba(40, 167, 69, 0.6)',
            borderRadius: '12px',
            color: '#51cf66',
            animation: 'fadeInUp 0.5s ease-out'
          }}>
            ✅ {t("Submission was successful")}! Preusmeravamo vas na početnu stranicu...
          </div>
        )}

      </div>
    </div>
  );
};

export default DailySurveyScreen;
